
import { termsOfService } from '@/constants'
export default {
  layout: 'whiteHeader',
  data() {
    return {
      termsOfService
    }
  },
  computed: {
    termsData() {
      return this.termsOfService[this.$i18n.locale]
    },
    premiumTerms() {
      return this.termsOfService[this.$i18n.locale].premiumTerms
    }
  },
  nuxtI18n: {
    paths: {
      en: '/terms-of-service',
      es: '/terminos',
      id: '/terms-of-service',
      br: '/terms'
    }
  },
  head() {
    return {
      link: [
        { rel: 'canonical', href: `https://home.trebel.io/${this.$i18n.locale && this.$i18n.locale !== 'en' ? this.$i18n.locale + '/terms-of-service' : '/terms-of-service'}` }
      ],
      title: "Trebel",
      meta: [
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: 'Terms of Service | TREBEL MUSIC: Free Music Download App for Android and iPhone' },
        { property: 'og:description', content: 'The best free music download app for Android phones and iPhone, iPod and iPad. Download free, play offline, no wifi, no data plan, no subscription.' },
        { property: 'og:image', content: 'https://images.projectcarmen.com/resource/ads/64e8a9ff927cbb6b7d0fdadd.jpeg' },
        { property: 'og:image:type', content: 'image/png' },
        { property: 'og:url', content: 'https://www.home.trebel.io' },
        { property: 'fb:app_id', content: '614494898692745' },
        { property: 'al:ios:app_store_id', content: '912390687' },
        { property: 'al:ios:url', content: 'https://www.home.trebel.io' },
        { property: 'al:ios:app_name', content: 'Trebel Music - Song Downloader' },
        { property: 'al:android:package', content: 'com.mmm.trebelmusic' },
        { property: 'al:android:url', content: `trebel:/${this.$route.fullPath}` },
        { property: 'al:android:app_name', content: 'TREBEL - Free Music Downloads' },
      ]
    }
  }
}
